import { TocItem } from '@doltech/ui/lib/figma/Layout/Landing/Content/TableOfContent/TableOfContentType';
import { StepType } from '@doltech/ui/lib/figma/Steps/StepsV2';
import { SpeakingSampleTypeEnum } from '@doltech/utils/lib/constants';

export const speakingPart1Step: StepType[] = [
  { name: 'Basic info', status: 'wait' },
  { name: 'Danh sách câu hỏi', status: 'wait' },
  { name: 'Bài mẫu & Vocab', status: 'wait' },
  { name: 'Tạo Flow Idea', status: 'wait' },
  { name: 'Nhập Vocab', status: 'wait' },
  { name: 'Nhập Exercise', status: 'wait' },
  { name: 'Preview', status: 'wait' },
  { name: 'Gán cho ai', status: 'wait' },
];

export const speakingPart2Step: StepType[] = [
  { name: 'Basic info', status: 'wait' },
  { name: 'Tạo dàn ý', status: 'wait' },
  { name: 'Bài mẫu & Vocab', status: 'wait' },
  { name: 'Tạo Flow Idea', status: 'wait' },
  { name: 'Nhập Vocab', status: 'wait' },
  { name: 'Nhập Exercise', status: 'wait' },
  { name: 'Preview', status: 'wait' },
  { name: 'Gán cho ai', status: 'wait' },
];

export const getStepBySampleType = (type) => {
  switch (type) {
    case SpeakingSampleTypeEnum.SPEAKING_PART_1: {
      return speakingPart1Step;
    }
    case SpeakingSampleTypeEnum.SPEAKING_PART_2: {
      return speakingPart2Step;
    }
    case SpeakingSampleTypeEnum.SPEAKING_PART_3: {
      return speakingPart1Step;
    }
    default:
  }
  return speakingPart1Step;
};

export const SpeakingPart1TocId = {
  DANH_SACH_CAU_HOI: 'danh-sach-cau-hoi',
  SAMPLE_TUNG_CAU: 'sample-tung-cau',
  VOCABULARY: 'vocabulary',
  EXERCISES: 'bai-tap-on-lai',
  LOI_KET: 'loi-ket',
} as const;

export type SpeakingPart1TocId = (typeof SpeakingPart1TocId)[keyof typeof SpeakingPart1TocId];

export const speakingPart1TableOfContent: TocItem[] = [
  {
    id: SpeakingPart1TocId.DANH_SACH_CAU_HOI,
    text: 'Danh sách câu hỏi',
    prefix: '🚀',
  },
  {
    id: SpeakingPart1TocId.SAMPLE_TUNG_CAU,
    text: 'Sample từng câu',
    prefix: '📝',
  },
  {
    id: SpeakingPart1TocId.VOCABULARY,
    text: 'Vocabulary',
    prefix: '📚',
  },
  {
    id: SpeakingPart1TocId.EXERCISES,
    text: 'Bài tập exercise',
    prefix: '✨',
  },
  {
    id: SpeakingPart1TocId.LOI_KET,
    text: 'Lời kết',
    prefix: '💡',
  },
];

export const SpeakingPart2TocId = {
  DE_BAI: 'de-bai',
  DAN_Y: 'dan-y',
  BAI_MAU: 'bai-mau',
  VOCABULARY: 'vocabulary',
  EXERCISES: 'bai-tap-on-lai',
  LOI_KET: 'loi-ket',
} as const;

export type SpeakingPart2TocId = (typeof SpeakingPart2TocId)[keyof typeof SpeakingPart2TocId];

export const speakingPart2TableOfContent: TocItem[] = [
  {
    id: SpeakingPart2TocId.DE_BAI,
    text: 'Đề bài',
    prefix: '🚀',
  },
  {
    id: SpeakingPart2TocId.DAN_Y,
    text: 'Dàn ý',
    prefix: '😵',
  },
  {
    id: SpeakingPart2TocId.BAI_MAU,
    text: 'Bài mẫu',
    prefix: '📝',
  },
  {
    id: SpeakingPart2TocId.VOCABULARY,
    text: 'Vocabulary',
    prefix: '📚',
  },
  {
    id: SpeakingPart2TocId.EXERCISES,
    text: 'Bài tập Exercise',
    prefix: '✨',
  },
  {
    id: SpeakingPart2TocId.LOI_KET,
    text: 'Lời kết',
    prefix: '💡',
  },
];
